<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">


      <div class="grid-menu grid-menu-2col">
        <div class="no-gutters row">

<!--          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessSubValidation('sub-general-setting-param')"
                      to="financial-setting-param">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Parâmetros
            </t-button>
          </div>-->

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('financial-creditor')"
                      to="financial-creditor">
              <i class="lnr-users btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Credores
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('financial-bank-account')"
                      to="financial-bank-account">
              <i class="lnr-briefcase btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Contas Bancárias
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('financial-chart-account')"
                      to="financial-chart-account">
              <i class="lnr-book btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Planos de Conta
            </t-button>
          </div>

        </div>
      </div>


<!--      <b-col v-for="relationPages in userAuth.relationPages" :key="relationPages.pageRelationId">
        {{ relationPages.pageTitle }}
      </b-col>-->

    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'FinancialSettings',
  data() {
    return {

    }
  },
  methods: {

    mountedPrepare(){


    },
    async mountedContinued(){

    }
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
